type TextCellProps = {
  value: string,
  subValue: string,
}

const TextCell = (props: TextCellProps) => {
  const { value, subValue } = props;
  return <>
    <span className='text-sm text-white'>{value}</span>
    {' '}
    <span className='text-sm text-white/[0.3]'>{subValue}</span>
  </>;
}

export default TextCell;